import _ from 'lodash';

export function getDatafromPath(data, path, defaultType) {
  return _.get(data, path, defaultType);
}
